import { useAtom } from "jotai";
import { useCallback, useEffect } from "react";
import { match } from "ts-pattern";

import { ConfirmationPage } from "./components/confirmation-page/confirmation-page.component";
import { Layout } from "./components/layout/layout.component";
import { OptInPage } from "./components/opt-in-page/opt-in-page.component";
import { SurveyPage } from "./components/survey-page/survey-page.component";
import { pagesAtom, snhuCompletedAtom } from "./snhu.state";
import { Pages } from "./snhu.types";


export function Widget() {
  const [page] = useAtom(pagesAtom);
  const [hasCompletedSNHU] = useAtom(snhuCompletedAtom);

  const skipSnhu = useCallback((): void => {
    window.theme.SnhuUtils.skip();
  }, []);

  useEffect(() => {
    hasCompletedSNHU && skipSnhu();
  }, [hasCompletedSNHU, skipSnhu]);

  return (
    <Layout>
      {match(page)
        .with(Pages.OPTIN, () => <OptInPage skipSnhu={skipSnhu} />)
        .with(Pages.SURVEY, () => <SurveyPage skipSnhu={skipSnhu} />)
        .with(Pages.CONFIRMATION, () => <ConfirmationPage skipSnhu={skipSnhu} />)
        .exhaustive()
      }
    </Layout>
  );
}
